const isBlank = (stringValue) => {
    return !(stringValue && stringValue !== "");
};

const isEmpty = (str) => {
    return str === undefined || str === null || 0 === str.length;
};
const combineStrings = (first, second, separator) => {
    if (!first) {
        return second;
    } else if (!second) {
        return first;
    } else {
        return first + (separator ? separator : "") + second;
    }
};

const combineStringList = (list, separator) => {
    return [...new Set(list)].filter((s) => !!s).join(separator);
};

const areBlank = (stringValues) => {
    let stringsAreBlank = false;
    stringValues.forEach((stringValue) => {
        if (isBlank(stringValue)) {
            stringsAreBlank = true;
        }
    });
    return stringsAreBlank;
};

const equals = (stringToCheck, stringToCheckAgainst) => {
    if (stringToCheck && stringToCheckAgainst) {
        return stringToCheck.normalize() === stringToCheckAgainst.normalize();
    } else {
        return stringToCheck === stringToCheckAgainst;
    }
};

const equalsIgnoreCase = (stringToCheck, stringToCheckAgainst) => {
    if (stringToCheck && stringToCheckAgainst) {
        return stringToCheck.toLowerCase().normalize() === stringToCheckAgainst.toLowerCase().normalize();
    } else {
        if (!stringToCheck && !stringToCheckAgainst) {
            return true;
        }
        return stringToCheck.toLowerCase() === stringToCheckAgainst.toLowerCase();
    }
};

const contains = (stringToCheck, stringToCheckAgainst) => {
    if (!isEmpty(stringToCheck) && !isEmpty(stringToCheckAgainst)) {
        return stringToCheck.includes(stringToCheckAgainst);
    } else {
        return false;
    }
};

const containsIgnoreCase = (stringToCheck, stringToCheckAgainst) => {
    if (!isEmpty(stringToCheck) && !isEmpty(stringToCheckAgainst)) {
        return stringToCheck.toLowerCase().includes(stringToCheckAgainst.toLowerCase());
    } else {
        return false;
    }
};

const clearWhiteSpace = (value) => {
    if (!value || !(value instanceof String)) {
        return value;
    }
    return value.replaceAll(" ", "");
};

const clearWhiteSpacesForEvent = (e) => {
    return {
        ...e,
        target: {
            ...e.target,
            [e.target.name]: stringUtils.clearWhiteSpace(e.target.value),
        },
    };
};

const anonymizeKeep5 = (value) => {
    if (value) {
        const firstTwo = value.slice(0, 5);
        let toBeAnonymized = value.slice(5, value.length - 5);
        toBeAnonymized = toBeAnonymized.replace(/[a-z]|[A-Z]|[0-9]|[_.-]*$/g, "*");
        const lastFive = value.slice(value.length - 5);
        return firstTwo + toBeAnonymized + lastFive;
    } else {
        return value;
    }
};

const isValidWooCommerceShopUrl = (url) => {
    return (containsHTTP(url) || containsHTTPS(url)) && endsWithTopLevelDomain(url);
};

const isValidShopifyShopUrl = (url) => {
    return (
        !(containsHTTP(url) && containsHTTPS(url)) &&
        !containsWWW(url) &&
        url.includes(".myshopify.") &&
        endsWithTopLevelDomain(url)
    );
};

const trimWWW = (url) => {
    return url.replace("www.", "");
};

const endsWithTopLevelDomain = (url) => {
    return url.endsWith(".de" || ".com");
};

const containsHTTP = (url) => {
    return url.startsWith("http://");
};

const containsHTTPS = (url) => {
    return url.startsWith("https://");
};

const containsWWW = (url) => {
    return url.includes("www.");
};

const adjustPropsForProductFruits = (input) => {
    if (typeof input === "string") {
        if (input.includes(";")) {
            return input.split(";").map((item) => (item === "SHOPIFY" ? "SHOPIFY_REVENUE" : item));
        } else {
            return input === "SHOPIFY" ? "SHOPIFY_REVENUE" : input;
        }
    }

    if (Array.isArray(input)) {
        return input.map((item) => (item === "SHOPIFY" ? "SHOPIFY_REVENUE" : item));
    }

    return input;
};

// Input is a string with '_' to annotate a required capitalization for the next word and '-' for word-separation
const singleStringToCamelCase = (input) => {
    if (!input) {
        return input;
    }

    return input
        .split("_")
        .reduce((accumulator, currentValue) => accumulator + capitalize(currentValue), "")
        .split("-")
        .reduce((accumulator, currentValue) => accumulator + " " + capitalize(currentValue), "");
};

// Input is a string with '_' to annotate a required capitalization for the next word and '-' for word-separation
const camelCaseToLowerCaseIdentifier = (input) => {
    if (!input) {
        return input;
    }

    return input
        .split(/(?=[A-Z])/)
        .join("-")
        .toLowerCase();
};

const capitalize = (input) => {
    return input.charAt(0).toUpperCase() + input.slice(1);
};

const prettyJsonString = (string) => {
    let obj = JSON.parse(string);
    return JSON.stringify(obj, undefined, 2);
};
const isNumericString = (str) => {
    if (typeof str != "string") {
        return false;
    } else {
        return !isNaN(str) && !isNaN(parseFloat(str));
    }
};

const randomString = () => {
    return String(Date.now().toString(32)) + Math.random().toString(16).replace(/\./g, "");
};

const formatUppercaseIdentifierToLowercase = (text) => {
    if (!text) {
        return text;
    }
    return text.replaceAll("_", "-").toLowerCase();
};

const singleStringToKebabCase = (str) => {
    return str.replace(/[_\s]/g, "-").toLowerCase();
};

const toLowerCase = (str) => {
    if (isBlank(str)) {
        return str;
    }

    return str.toLowerCase();
};

const toUppercase = (str) => {
    if (isBlank(str)) {
        return str;
    }

    return str.toUppercase();
};

const stringUtils = {
    isBlank,
    isEmpty,
    areBlank,
    equals,
    equalsIgnoreCase,
    contains,
    containsIgnoreCase,
    clearWhiteSpace,
    clearWhiteSpacesForEvent,
    anonymizeKeep5,
    isValidWooCommerceShopUrl,
    isValidShopifyShopUrl,
    trimWWW,
    combineStrings,
    combineStringList,
    capitalize,
    singleStringToCamelCase,
    camelCaseToLowerCaseIdentifier,
    adjustPropsForProductFruits,
    prettyJsonString,
    isNumericString,
    randomString,
    formatUppercaseIdentifierToLowercase,
    singleStringToKebabCase,
    toLowerCase,
    toUppercase,
};

export default stringUtils;
